import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaWhatsapp,
} from 'react-icons/fa';

import A from '../../../shared/Anchor/Anchor';
import Link from '../../Link/Link';
import Login from '../HeaderMenu/Login/Login';
import LoginIcon from '../../Icons/Login';
import Assistenza from '../../Icons/Assistenza';
import Spedizione from '../../Icons/Spedizione';

import './TopHeader.scss';
import { LogoX } from '../../Icons/LogoX';

class TopHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLogin: false,
    };
  }

  // LOGIN
  toggleLogin = event => {
    event.preventDefault();

    this.setState({
      showLogin: !this.state.showLogin,
    });
  };

  closeLogin = event => {
    this.setState({
      showLogin: false,
    });
  };

  render() {
    const { showLogin } = this.state;
    const {
      isCheckout,
      user,
      isAuthenticated,
      onLogin,
      phone,
      phone2,
      hasBlog,
      posts,
      couponPageUrl,
      loginError,
      primaryColor,
      datiFarmacia,
      createUser,
      facebookAppId,
      hasFacebookLogin,
      shippingDescription,
      discounted,
    } = this.props;

    return (
      <div className="top-header" style={{ backgroundColor: primaryColor }}>
        <div className="desktop-version">
          {!isCheckout && (
            <div className="container">
              <div className="left-top-header">
                <nav className="navbar navbar-expand-sm m-0 p-0">
                  <ul className="navbar-nav">
                    {!!discounted.length && (
                      <li>
                        <Link
                          to="/prodotti-in-offerta"
                          className="link d-inline-block py-1 pr-2 pl-0 mr-2 text-white"
                        >
                          Offerte
                        </Link>
                      </li>
                    )}
                    {!!hasBlog && posts.length > 0 && (
                      <li>
                        <Link
                          to="/blog"
                          className="link d-inline-block py-1 px-2 mr-2 text-white"
                        >
                          Blog
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        to="/pagine/contattaci"
                        className="link d-inline-block py-1 px-2 mr-2 text-white"
                      >
                        Contatti
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/pagine/servizi"
                        className="link d-inline-block py-1 px-2 mr-2 text-white"
                      >
                        Servizi
                      </Link>
                    </li>
                    {/* <li>
                      <Link
                        to="/pagine/info-acquisti"
                        className="link d-inline-block py-1 px-2 mr-2 text-white"
                      >
                        Info acquisti
                      </Link>
                    </li> */}
                    {!!hasBlog && !!couponPageUrl && (
                      <li>
                        <a
                          className="link d-inline-block py-1 px-2 mr-2 text-white"
                          href={couponPageUrl}
                        >
                          Coupon
                        </a>
                      </li>
                    )}
                  </ul>
                </nav>
              </div>
              <div className="right-top-header">
                <nav className="navbar navbar-expand-sm navbar-right p-0">
                  {!isAuthenticated ? (
                    <Login
                      user={user}
                      isAuthenticated={isAuthenticated}
                      onLogin={onLogin}
                      showLogin={showLogin}
                      onToggleLogin={this.toggleLogin}
                      onCloseLogin={this.closeLogin}
                      onCloseAll={this.closeLogin}
                      loginError={loginError}
                      primaryColor={primaryColor}
                      onLoginFacebook={this.props.onLoginFacebook}
                      facebookAppId={this.props.facebookAppId}
                      hasFacebookLogin={hasFacebookLogin}
                      createUser={createUser}
                    />
                  ) : (
                    <span className="welcome-user">
                      <Link to="/profilo">
                        <LoginIcon /> Ciao{' '}
                        {user && user.billing && user.billing.firstname}
                      </Link>
                    </span>
                  )}
                  {(datiFarmacia.socialTwitterLink ||
                    datiFarmacia.socialFacebookLink ||
                    datiFarmacia.socialInstagramLink) && (
                    <div className="social">
                      {datiFarmacia.socialTwitterLink && (
                        <A
                          className="social-link"
                          href={datiFarmacia.socialTwitterLink}
                          target="_blank"
                        >
                          <LogoX
                            fill="#fff"
                            transform="translateY(5px) scale(0.5)"
                          />
                        </A>
                      )}
                      {datiFarmacia.socialFacebookLink && (
                        <A
                          className="social-link"
                          href={datiFarmacia.socialFacebookLink}
                          target="_blank"
                        >
                          <FaFacebookF />
                        </A>
                      )}
                      {datiFarmacia.socialInstagramLink && (
                        <A
                          className="social-link"
                          href={datiFarmacia.socialInstagramLink}
                          target="_blank"
                        >
                          <FaInstagram />
                        </A>
                      )}
                    </div>
                  )}
                </nav>
              </div>
            </div>
          )}
        </div>

        <div className="mobile-version">
          {!isCheckout && (
            <div className="container">
              <div className="mobile-top-header">
                <div className="mobile-top-header-item">
                  <Spedizione /> {shippingDescription}
                </div>
                {!!phone && (
                  <div className="mobile-top-header-item">
                    <Assistenza />
                    <a href={'tel:' + phone} style={{ color: 'white' }}>
                      {phone}
                    </a>
                  </div>
                )}
                {!!phone2 && (
                  <div className="mobile-top-header-item">
                    <FaWhatsapp />
                    <a
                      href={'https://wa.me/' + phone2}
                      style={{ color: 'white' }}
                    >
                      {phone2}
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    hasBlog: state.store.data.features.hasBlog,
    posts: state.posts.data.latest,
    couponPageUrl: state.store.data.funzionalita.couponPageUrl,
    discounted: state.homeProducts.data.discounted,
    loginError: state.user.error,
    datiFarmacia: state.store.data.datiFarmacia,
    facebookAppId: state.store.data.integrazioni.facebook.appId,
    hasFacebookLogin: state.store.data.features.hasFacebookLogin,
    shippingDescription: state.store.data.home.shippingDescription,
  };
}

export default connect(mapStateToProps)(TopHeader);
